import { Html } from "@react-three/drei";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
const Loader = () => {
  return (
    <Html center>
      <Skeleton className="gg-h-[26rem] sm:gg-h-[36rem] md:gg-h-[43rem] md:gg-px-2 xl:gg-h-[39.3rem] lg:gg-h-[46rem] 2xl:gg-h-[47rem] gg-aspect-square" />
    </Html>
  );
};

export default Loader;
